export const loadingStatus = {
    notStarted: -1,
    isLoading: 0,
    success: 1,
    failed: 2
};